import React from 'react';
import FirstTab from './FirstTab';
import SecondTab from './SecondTab';

function TabBody(props) {
    const { values, checkboxHandleChange, setChartVisibleStyle } = props;
    return (
        <React.Fragment>
            <FirstTab values={values} checkboxHandleChange={checkboxHandleChange} setChartVisibleStyle={setChartVisibleStyle} />
            <SecondTab values={values} checkboxHandleChange={checkboxHandleChange} setChartVisibleStyle={setChartVisibleStyle} />
        </React.Fragment>
    )
}

export default TabBody;